import type { ReactNode } from 'react';

/**
 * A WORD NOBODY HAS DECIDED YET (DESIGN.md D4, Part 3 item 6: "placeholder words carry a dotted
 * underline and an OPEN id in the report"). The words stand as written, dotted, with the id the
 * ledger lists them under in `data-open-word`, so a reviewer and a check can find every one; the
 * owner's word replaces them and the part goes. `EmptyState`, the toast and the dialog's
 * description draw it for the words they print when given the id.
 */
export interface OpenWordProps {
  /** The OPEN id the ledger lists the words under, "OPEN-WORD-4". */
  readonly id: string;
  readonly children: ReactNode;
}

export function OpenWord({ id, children }: OpenWordProps) {
  return (
    <span
      data-open-word={id}
      className="underline decoration-ink-subtle decoration-dotted underline-offset-4"
    >
      {children}
    </span>
  );
}
